import { GET_ROAD_FORECAST_BY_LOCATION } from '../actions/roadForecastActions';

const initialState = {
    roadForecastIsRefreshing: false
};

export function roadForecast(state = initialState, action) {
    switch(action.type) {
        case GET_ROAD_FORECAST_BY_LOCATION.pending: {
            return {
                ...state
                , roadForecastIsRefreshing: true
                , roadForecast: undefined
            };
        }

        case GET_ROAD_FORECAST_BY_LOCATION.fulfilled: {
            return {
                ...state
                , roadForecastIsRefreshing: false
                , roadForecast: action.payload
                , lastError: undefined
            };
        }

        case GET_ROAD_FORECAST_BY_LOCATION.rejected: {
            return {
                ...state
                , roadForecastIsRefreshing: false
                , lastError: action.payload
                , roadForecast: undefined
            };
        }

        default: {
            return state;
        }
    }
}

